import dayjs from 'dayjs';
import { dateHelper } from './dateHelper';

function ableToPersitDuThuChi(academicYear) {
    const academicYears = dateHelper.getYearsFromAcademicYear(academicYear);
    return !dayjs().isAfter(dayjs(`${academicYears[0]}-11-01`));
}

function getStudentFullName(student) {
    return `${student.lastName} ${student.firstName}`;
}

export const commonHelpers = {
    ableToPersitDuThuChi,
    getStudentFullName,
};
